import { Box } from "@mui/material";
import CardsContainer from "../components/Home/CardsContainer";
import HeaderHome from "../components/Home/HeaderHome";
import FreshDeskBtn from "../utils/FreshDeskBtn";

const Menu = () => {
  return (
    <Box
      sx={{
        maxWidth: "1400px",
        width: "100%",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        mt: { xs: 1, sm: 0 },
        px:{xs:0, sm:2, xl:0},
        py:4
      }}
    >
      {/* Componente Bienvenida */}
      <HeaderHome />

      {/* Contenedor de Tarjetas */}
      <CardsContainer />
      <FreshDeskBtn />
    </Box>
  );
};

export default Menu;
